import React from 'react';
import { Button } from './common/Button';
import { CheckIcon } from 'lucide-react';
export function SplitSection() {
  const shopperBenefits = ['Automatic rewards at local businesses', 'No apps to open when shopping', 'Discover new local favorites', 'Special perks for loyal customers', 'Share with friends for bonus points'];
  const merchantBenefits = ['No hardware or special equipment needed', 'Works with your existing payment system', 'Detailed customer insights dashboard', 'Customizable reward programs', 'Increase repeat customer visits'];
  const brandBenefits = ['Sponsor in-store perks', 'Run Drops for new products & offers', 'Personalised perks for repeat buyers', 'Activate underperforming stores', 'Turn cafés into sampling channels'];
  return <section className="py-16 bg-[#f0ebff]" data-id="element-423">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-424">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-425">
          {/* Shoppers Side */}
          <div className="bg-white rounded-2xl shadow-sm p-8 hover:shadow-md transition-shadow duration-200" data-id="element-426">
            <div className="mb-6" data-id="element-427">
              <h3 className="text-2xl font-bold mb-4" data-id="element-428">For Shoppers</h3>
              <div className="h-1 w-12 bg-[#A020F0]" data-id="element-429"></div>
            </div>
            <ul className="space-y-3 mb-8" data-id="element-430">
              {shopperBenefits.map((benefit, index) => <li key={index} className="flex items-start" data-id="element-431">
                  <div className="bg-[#A020F0] rounded-full p-1 mr-3 mt-0.5 flex-shrink-0" data-id="element-432">
                    <CheckIcon className="h-4 w-4 text-white" data-id="element-433" />
                  </div>
                  <span data-id="element-434">{benefit}</span>
                </li>)}
            </ul>
            <Button variant="secondary" size="lg" href="https://kraya.live/" onClick={e => {
            e.preventDefault();
            window.open('https://kraya.live/', '_blank');
          }} data-id="element-435">
              Join Waitlist
            </Button>
          </div>

          {/* Merchants Side */}
          <div id="merchants" className="bg-white rounded-2xl shadow-sm p-8 hover:shadow-md transition-shadow duration-200" data-id="element-436">
            <div className="mb-6" data-id="element-437">
              <h3 className="text-2xl font-bold mb-4" data-id="element-438">For Merchants</h3>
              <div className="h-1 w-12 bg-[#A020F0]" data-id="element-439"></div>
            </div>
            <ul className="space-y-3 mb-8" data-id="element-440">
              {merchantBenefits.map((benefit, index) => <li key={index} className="flex items-start" data-id="element-441">
                  <div className="bg-[#A020F0] rounded-full p-1 mr-3 mt-0.5 flex-shrink-0" data-id="element-442">
                    <CheckIcon className="h-4 w-4 text-white" data-id="element-443" />
                  </div>
                  <span data-id="element-444">{benefit}</span>
                </li>)}
            </ul>
            <Button variant="secondary" size="lg" href="https://kraya.shop/" data-id="element-445">
              Partner With Us
            </Button>
          </div>

          {/* Brands Side */}
          <div id="brands" className="bg-white rounded-2xl shadow-sm p-8 hover:shadow-md transition-shadow duration-200" data-id="element-446">
            <div className="mb-6" data-id="element-447">
              <h3 className="text-2xl font-bold mb-4" data-id="element-448">For Brands</h3>
              <div className="h-1 w-12 bg-[#A020F0]" data-id="element-449"></div>
            </div>
            <ul className="space-y-3 mb-8" data-id="element-450">
              {brandBenefits.map((benefit, index) => <li key={index} className="flex items-start" data-id="element-451">
                  <div className="bg-[#A020F0] rounded-full p-1 mr-3 mt-0.5 flex-shrink-0" data-id="element-452">
                    <CheckIcon className="h-4 w-4 text-white" data-id="element-453" />
                  </div>
                  <span data-id="element-454">{benefit}</span>
                </li>)}
            </ul>
            <Button variant="secondary" size="lg" href="mailto:hello@kraya.shop" data-id="element-455">
              Get Started
            </Button>
          </div>
        </div>
      </div>
    </section>;
}